/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react';

export default {
  title: 'HSBC traditional Chinese English logo',
  viewBox: '0 0 527.2 144.6',
  svgContent: (
    <>
      <g id="HSBC_MASTERBRAND_ENG_TC_WW_CMYK">
        <rect x="-141.4" y="-140.8" fill="none" width="810.1" height="424.8" />
        <polygon fill="#DB0011" points="283.8,71.6 212.9,0.7 212.9,142.4 	" />
        <rect x="71.2" y="0.7" fill="#FFFFFF" width="141.7" height="141.7" />
        <polygon fill="#DB0011" points="142.1,71.6 212.9,0.7 71.2,0.7 	" />
        <polygon fill="#DB0011" points="0.3,71.6 71.2,142.4 71.2,0.7 	" />
        <polygon fill="#DB0011" points="142.1,71.6 71.2,142.4 212.9,142.4 	" />
        <path d="M346,116.6h-25.7V142h-12.9V82.6h12.9v24.3H346V82.6h12.9V142H346V116.6z" />
        <path
          d="M389.8,143.4c-12.8,0-23.3-5.1-23.6-19.3h12.9c0.2,6.3,3.9,10.1,10.9,10.1c5.2,0,11.2-2.6,11.2-8.5c0-4.6-4-6.1-10.7-8
		l-4.3-1.2c-9.4-2.7-18.6-6.3-18.6-17c0-13.2,12.3-17.6,23.6-17.6c11.6,0,21.5,4,21.6,17.1h-12.9c-0.5-5.4-3.6-8.5-9.7-8.5
		c-4.8,0-9.5,2.5-9.5,7.8c0,4.4,3.9,5.7,12.3,8.3l4.9,1.6c10.2,3.2,16.6,6.7,16.6,16.6C414.5,138.2,401.4,143.4,389.8,143.4z"
        />
        <path
          d="M421.7,83h20.6c6.5,0,9.1,0.2,11.7,0.7c7.2,1.6,12.6,6.3,12.6,14.3c0,7.6-4.8,11.6-11.8,13.4c8,1.5,14,5.6,14,14.4
		c0,13.5-13.3,16.6-23.7,16.6h-23.3V83z M442.4,107.7c5.7,0,11.4-1.1,11.4-8c0-6.2-5.4-7.8-10.6-7.8h-9v15.8L442.4,107.7z
		 M443.6,133.4c6,0,11.9-1.4,11.9-8.6c0-7.1-5.1-8.7-11.2-8.7h-10.1v17.3H443.6z"
        />
        <path
          d="M502.3,143.4c-19.1,0-27.7-12.2-27.7-30.3c0-17.9,9.5-31.3,28.4-31.3c11.8,0,23.3,5.2,23.6,18.7h-13.3
		c-0.7-5.9-4.6-9-10.3-9c-11.6,0-15.1,12.5-15.1,22c0,9.5,3.5,20.4,14.7,20.4c5.8,0,10.1-3.1,11-9.1H527
		C525.5,138.3,514.7,143.4,502.3,143.4z"
        />
        <path d="M362.6,31.2l4.9-4.7c-3-3.6-6.3-6.8-10-9.7l-4.4,4.7C356.6,24.4,359.7,27.7,362.6,31.2z" />
        <path d="M359.8,61c3.6-7.3,6.5-14.9,8.5-22.8l-6.1-2.7c-1.6,7.6-4.5,14.8-8.6,21.5L359.8,61z" />
        <path d="M358.9,0.7l-4.1,4.6c3.5,2.7,6.8,5.8,9.6,9.2l4.6-4.9C366,6.2,362.6,3.3,358.9,0.7z" />
        <polygon points="376.8,8 414.3,8 414.3,2.5 370.2,2.5 370.2,59.5 414.3,59.5 414.3,53.9 376.8,53.9 	" />
        <path
          d="M397.7,16.2h-8.4l0.2-0.4c0.8-1.5,1.4-3,2-4.5l-5.6-2.1c-1.9,5.4-4.6,10.5-8,15.1l2.5,6.6c0.7-0.7,1.3-1.5,1.8-2.3l0.5-0.8
		v24.1h6.3v-1.6h23.2v-5.5h-9.8v-4.2h7.7v-5.3h-7.7v-4.2h7.7v-5.3h-7.7v-3.9h9.8v-5.6h-11L404,14c-1.4-1.9-3.2-3.6-5.2-4.9l-4.4,3.7
		L397.7,16.2z M396.1,44.7h-7.1v-4.2h7.1V44.7z M396.1,35.2h-7.1v-4.2h7.1V35.2z M396.1,25.6h-7.1v-3.9h7.1V25.6z"
        />
        <polygon
          points="466.9,21 471.4,21 471.4,16.9 466.9,16.9 466.9,14.1 470.6,14.1 470.6,10.1 466.9,10.1 466.9,7.5 471.4,7.5 
		471.4,3.5 466.9,3.5 466.9,0.8 461.3,0.8 461.3,3.5 456.8,3.5 456.8,7.5 461.3,7.5 461.3,10.1 457.6,10.1 457.6,14.1 461.3,14.1 
		461.3,16.9 456.8,16.9 456.8,21 461.3,21 461.3,23.8 454.8,23.8 454.8,0.6 449.2,0.6 449.2,23.8 442.6,23.8 442.6,21 447.1,21 
		447.1,16.9 442.6,16.9 442.6,14.1 446.3,14.1 446.3,10.1 442.6,10.1 442.6,7.5 447.1,7.5 447.1,3.5 442.6,3.5 442.6,0.8 437,0.8 
		437,3.5 432.5,3.5 432.5,7.5 437,7.5 437,10.1 433.4,10.1 433.4,14.1 437,14.1 437,16.9 432.5,16.9 432.5,21 437,21 437,23.8 
		430.5,23.8 430.5,2.7 424.6,2.7 424.6,28.3 479.3,28.3 479.3,2.7 473.4,2.7 473.4,23.8 466.9,23.8 	"
        />
        <rect x="422.3" y="31.2" width="59.4" height="4.6" />
        <path
          d="M466.4,54.6c0.9-1.3,1.7-2.6,2.3-3.9l0.1-0.1h6.5V38.6h-46.8v11.9h6.5l3,4.5h-16.3v4.5H482V55h-15.9L466.4,54.6z
		 M435.2,46.3v-3.4h33.5v3.4H435.2z M461.6,50.9c-0.7,1.4-1.6,2.8-2.7,4l-0.1,0.1h-13.2l-0.1-0.1c-0.6-1.1-1.4-2.5-2.4-4l-0.2-0.4
		h18.8L461.6,50.9z"
        />
      </g>
    </>
  ),
};
